import {Directive, EventEmitter, HostListener, Output} from '@angular/core';

export type ChangeOrientationEvent = {
    orientation: 'landscape' | 'portrait',
    currentWidth: number,
    currentHeigth: number
}

@Directive({
    selector: '[appChangeOrientation]',
    standalone: false
})
export class ChangeOrientationDirective {

    @Output() changeOrientation = new EventEmitter<ChangeOrientationEvent>();

    constructor() {
    }


    @HostListener('window:orientationchange', ['$event'])
    onOrientationChange(event: any) {
        const width = window.innerWidth;
        const heigth = window.innerHeight;
        if (width < heigth) {
            this.changeOrientation.emit({
                orientation: 'landscape',
                currentWidth: heigth,
                currentHeigth: width
            })
        } else {
            this.changeOrientation.emit({
                orientation: 'portrait',
                currentWidth: heigth,
                currentHeigth: width
            })
        }
    }

}
